/* LMM T8/T5 hierarchy shared utilities. */
(function () {
  'use strict';
  if (window.LMMTubeHierarchy) return;
  function readData() {
    var el = document.getElementById('lmm-tube-hierarchy-data');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function esc(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#039;');
  }
  function norm(value) {
    return String(value || '').toLowerCase().trim()
      .replace(/ä/g,'ae').replace(/ö/g,'oe').replace(/ü/g,'ue').replace(/ß/g,'ss')
      .replace(/[–—−_\/\\+\-]+/g,' ').replace(/[^a-z0-9.,°\s]/g,' ')
      .replace(/\s+/g,' ').trim();
  }
  function countMarkup(item, cls) {
    return item && Number(item.count) > 0
      ? '<span class="' + (cls || 'mc') + '">' + Number(item.count).toLocaleString('de-DE') + '</span>'
      : '';
  }
  function pathHandle() {
    var m = /^\/collections\/([a-z0-9-]+)/.exec(location.pathname);
    return m ? m[1] : '';
  }
  function previewUrl(path) {
    var target = new URL(path, location.origin);
    var current = new URL(location.href);
    ['preview_theme_id','preview_key'].forEach(function (key) {
      if (current.searchParams.has(key) && !target.searchParams.has(key)) {
        target.searchParams.set(key, current.searchParams.get(key));
      }
    });
    return target.pathname + target.search;
  }
  function link(item, cls) {
    return '<a' + (cls ? ' class="' + cls + '"' : '') + ' href="' + esc(item.url) + '"><span>' +
      esc(item.title) + '</span>' + countMarkup(item, 'lmmh-mc') + '</a>';
  }
  function group(title, items) {
    return '<div class="lmmh-grp"><h3 class="lmmh-grp__head"><span class="lmmh-grp__label">' +
      '<span class="lmmh-grp__text">' + esc(title) + '</span></span></h3><ul>' +
      items.map(function (item) { return '<li>' + link(item) + '</li>'; }).join('') +
      '</ul></div>';
  }
  window.LMMTubeHierarchy = {
    data: readData(), esc: esc, norm: norm, countMarkup: countMarkup,
    pathHandle: pathHandle, previewUrl: previewUrl, link: link, group: group
  };
})();
